export default __webpack_public_path__ + "static/media/HDTX_Announcement of GMS 2023.8f130920.pdf";